import { isPlainObject, isString } from "lodash";

export const maskValue = (value: string | number, mask: string | {
  exp: string;
  flags?: string | undefined;
}) => {
  if (isPlainObject(mask) && isString(value)) {
    const { exp, flags } = mask as any;
    if (!isString(exp) || (flags && !isString(flags))) return value;
    let filteredText = '';
    const pattern = new RegExp(exp, flags);
    for (let i = 0; i < value.length; i++) {
      const checkValue = filteredText + value[i];
      if (pattern.test(checkValue)) {
        filteredText += value[i];
      }
    }
    return filteredText;
  } else if (isString(mask)) {
    try {
      const fn = new Function('v', mask);
      return fn(value);
    } catch {
      return value;
    }
  } else {
    return value;
  }
};
